import { Tween } from "@westpierstudio/luma/createjs";
import { View } from "@westpierstudio/luma/mvc";
import { ExternalItem } from "@westpierstudio/luma/utils/elastic-cache";
import { GameServices } from "game/GameServices";
import { BonusSymbolID, CoreSymbolID, SymbolID, WildSymbolID } from "servertypes/SharedTypes";
import { Signal } from "type-signals";
import { SymbolCache } from "./Reels";
import { Spine } from "pixi-spine";
import { Graphics, Sprite, Texture } from "pixi.js";
import { ReelsLayout, ReelsSpec } from "./ReelsModel";
import { AssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { error } from "console";

class ReelSymbolSignals {
    scatterWinComplete = new Signal();
}

export class ReelSymbol extends View {
    private spine?: ExternalItem<Spine>;
    private _id: SymbolID = CoreSymbolID.M1;
    signals = new ReelSymbolSignals();

    constructor(protected override readonly services: GameServices, private readonly symbolCache: SymbolCache) {
        super(services);

        this.addListener(`click`, this.onInteract, this)
            .addListener(`tap`, this.onInteract, this);
    }

    get id() {
        return this._id;
    }

    setSymbol(id: SymbolID): void {

        if (this._id !== id || this.spine === undefined) {

            if (this.spine) {

                this.removeChild(this.spine.reference);
                this.symbolCache[this._id].free(this.spine);
            }

            this._id = id;
            this.spine = this.symbolCache[this._id].get();
            this.addChildAt(this.spine.reference, 0);

            if (id === WildSymbolID.WX) {
                this.spine.reference.skeleton.setSkinByName(`robin-hood-top`);
            }
            else if (id === WildSymbolID.WY) {
                this.spine.reference.skeleton.setSkinByName(`robin-hood-bottom`);
            }
        }

        this.setAnimStaticState();
    }

    startWinAnim(loop: boolean): void {
        if (this.spine) {
            this.animationSymbolHigh(loop);
        }
    }

    animationSymbolHigh(loop: boolean) {
        if (this.spine) {
            const state = this.spine.reference.state;
            state.setAnimation(0, `win`, loop);
        }
    }

    scatterWinSequence(): void {
        Tween.get(this)
            .wait(3000)
            .call(() => {
                this.signals.scatterWinComplete.dispatch();
            });
    }

    scatterWinLoop(): void {
    }

    stopWinAnimLoop(): void {
        this.setAnimStaticState();
    }

    playBonusLandAnim(): void {
        if (this.id == BonusSymbolID.B1 && this.spine) {
            this.spine.reference.state.setAnimation(0, `bonus`, false);
        }
    }

    bonusCompleteAnimation() {
        if (this.id == BonusSymbolID.B1 && this.spine) {
            this.spine.reference.state.setAnimation(0, `bonus-complete`, true);
        }
    }

    bonusExtraFreeSpinsAnimation() {
        if (this.id == BonusSymbolID.B1 && this.spine) {
            this.spine.reference.state.setAnimation(0, `bonus-extra`, true);
        }
    }

    bonusInitiatedAnimation() {
        if (this.id == BonusSymbolID.B1 && this.spine) {
            this.spine.reference.state.setAnimation(0, `bonus-initiated`, true);
        }
    }

    setInteractive(interactive: boolean) {
        this.interactive = this.buttonMode = interactive;
    }

    override reset(): void {
        if (this.spine) {
            this.spine.reference.skeleton.setToSetupPose();
        }
    }

    private setAnimStaticState(): void {
        if (this.spine) {
            this.spine.reference.state.clearTrack(0);
            this.spine.reference.skeleton.setToSetupPose();
            this.spine.reference.state.clearListeners();
        }
    }

    private onInteract(): void {
    }
}